import React from 'react';
import { useTranslations } from './contexts/TranslationContext';

// ponytail: renders the audit list the server already prepared; no pagination,
// no diff view. Add an API-backed panel if articles start accumulating many audits.
export default function ChangeHistory({ entries }) {
  var t = useTranslations();
  var list = entries || [];

  return (
    <div className="form-sidebar__section">
      <h6 className="form-sidebar__heading">
        <i className="zmdi zmdi-time-restore zmdi-hc-fw" /> {t.change_history}
      </h6>
      {list.length === 0 ? (
        <p className="small text-muted mb-0">{t.change_history_empty}</p>
      ) : (
        <ul className="list-unstyled mb-0">
          {list.map(function(entry, i) {
            return (
              <li key={i}>
                <div className="small">{t.changed_by} {entry.by || '-'}</div>
                <div className="small text-muted">{entry.at}</div>
                {entry.fields && entry.fields.length > 0 && (
                  <div className="mt-1">
                    {entry.fields.map(function(field) {
                      return (
                        <span key={field} className="badge bg-light mr-1">{field.replace(/_/g, ' ')}</span>
                      );
                    })}
                  </div>
                )}
                {i !== list.length - 1 && <hr className="my-2" />}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
